
import PopupContentView from '../../../modules/popup-content/js/views/popup-content.js';

export default class MobileTabs {
	constructor({ el }) {
		this.modal = null;
		this.el = document.querySelector(el);
		this.initHistory();
		this.checkLocationHash();
	}

	closeTabContent() {
		if( this.modal ) {
			this.modal.close();
			this.modal = null;
		}
	}

	showTabContent( tab_id ) {
		this.closeTabContent();

		const content = document.querySelector( tab_id );

		this.modal = new PopupContentView({
			el: '.modal-content-placeholder',
			modal_selector: '#app-modal-content',
			isOpened: () => {
				this.modal.content.append( content );
				content.classList.remove('d-none');
			},
			isClosed: () => {
				content.classList.add('d-none');
				document.querySelector('body').append( content );
				//if( window.location.hash === tab_id ) {
				//	window.location.hash = '';
				//}
			},
			navigation: {
				image: window.ProductInfo.Image,
				caption: window.ProductInfo.Name
			}
		});
	}

	initHistory() {

		var pushState = window.history.pushState;

		window.history.pushState = function(state) {
			if (typeof window.history.onpushstate == "function") {
				window.history.onpushstate({state: state});
			}
			return pushState.apply(window.history, arguments);
		}

		// Listner
		window.onpopstate = window.history.onpushstate = e => {
			this.checkLocationHash();
		}
	}

	checkLocationHash() {
		switch( window.location.hash ) {
			case '#description':
			case '#options':
			case '#reviews':
			case '#videos':
				this.showTabContent( window.location.hash );
			break;
			default: this.closeTabContent();
		}
	}
}